module.exports = __webpack_public_path__ + "components/country-flag/static/va-b1af48492116b3ff28582231bf013f60.svg";